export const salesStatus = {
  progress: 'En progreso',
  completed: 'Completada',
  canceled: 'Cancelada'
}

export const deliveryCharge = 6;